import * as React from "react";
import {
  Typography,
  Paper,
  IconButton,
  InputBase,
  Box,
  Container,
  Pagination,
  MenuItem,
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Select,
  FormHelperText,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Stack,
  TextField,
} from "@mui/material";
import { connect } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  main_button,
  sec_button,
  StyledInput,
} from "../../app/components/Styles";
import moment from "moment";
import { getEventTickets } from "../../app/store/actions/adminActions";
import { useParams } from "react-router-dom";
import TicketRow from "./components/TicketRow";
import { motion } from "framer-motion";
import {
  PlatformPage,
  PlatformPageHeader,
  PlatformCard,
  PlatformButton,
  PlatformEmptyState,
  PlatformLoadingBlock,
  PlatformFilterChip,
} from "../../app/components/platform";
import {
  platformFilterSelectSx,
  platformTableSx,
  platformTableContainerSx,
} from "../../app/components/tickitPlatformTheme";

export const Tickets = ({ tickets, isLoading, getEventTickets }) => {
  const { id } = useParams();
  const [action, setAction] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");

  const initialState = {
    validated: "any",
    fulfilled: "any",
    refund: "any",
    generated: "any",
    emailStatus: "any",
    searchQuery: "",
    eventId: id,
    page: 1,
    limit: 50,
  };

  React.useEffect(() => {
    getEventTickets(initialState);
  }, []);

  const [formData, setFormData] = React.useState(initialState);
  const { validated, generated, fulfilled, refund, emailStatus } = formData;

  const ticketDocs = tickets?.docs || [];
  const pageFailedEmails = ticketDocs.filter((t) => t.emailStatus === "failed").length;

  const applyFilters = (overrides) => {
    const next = { ...formData, ...overrides };
    setFormData(next);
    getEventTickets(next);
  };

  const handleClearFilter = (event) => {
    setFormData(initialState);
    setSearchQuery("");
    getEventTickets(initialState);
  };

  const { page } = formData;

  const handlePageChange = (event, value) => {
    setFormData({ ...formData, page: value });
    getEventTickets({ ...formData, page: value });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    setFormData({ ...formData, searchQuery: value });
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearchFilter();
    }
  };

  const handleSearchFilter = (event) => {
    getEventTickets(formData);
  };

  const filterSelectSx = platformFilterSelectSx;

  React.useEffect(() => {
    getEventTickets(formData);
  }, [action]);

  return (
    <PlatformPage>
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        <PlatformPageHeader
          title="Tickets"
          subtitle="Search, filter, and manage issued tickets for this event"
        />
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
          <PlatformFilterChip
            label="All emails"
            active={formData.emailStatus === "any"}
            onClick={() => applyFilters({ emailStatus: "any", page: 1 })}
          />
          <PlatformFilterChip
            label="Failed emails"
            active={formData.emailStatus === "failed"}
            badge={pageFailedEmails > 0 ? pageFailedEmails : null}
            onClick={() => applyFilters({ emailStatus: "failed", page: 1 })}
          />
          <PlatformFilterChip
            label="Delivered"
            active={formData.emailStatus === "delivered"}
            onClick={() => applyFilters({ emailStatus: "delivered", page: 1 })}
          />
          <PlatformFilterChip
            label="Opened"
            active={formData.emailStatus === "opened"}
            onClick={() => applyFilters({ emailStatus: "opened", page: 1 })}
          />
        </Stack>
        <PlatformCard title="Filters" sx={{ mb: 2.5 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Validated</InputLabel>
                <Select
                  value={validated}
                  label="Validated"
                  name="validated"
                  onChange={handleChange}
                  sx={filterSelectSx}
                >
                  <MenuItem value={true} sx={{ color: "#1f1f1f" }}>Validated</MenuItem>
                  <MenuItem value={false} sx={{ color: "#1f1f1f" }}>Unvalidated</MenuItem>
                  <MenuItem value={"any"} sx={{ color: "#1f1f1f" }}>Any</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Payment Complete</InputLabel>
                <Select
                  value={fulfilled}
                  label="Payment Complete"
                  name="fulfilled"
                  onChange={handleChange}
                  sx={filterSelectSx}
                >
                  <MenuItem value={true} sx={{ color: "#1f1f1f" }}>Yes</MenuItem>
                  <MenuItem value={false} sx={{ color: "#1f1f1f" }}>No</MenuItem>
                  <MenuItem value={"any"} sx={{ color: "#1f1f1f" }}>Any</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Refunding</InputLabel>
                <Select
                  value={refund}
                  label="Refunding"
                  name="refund"
                  onChange={handleChange}
                  sx={filterSelectSx}
                >
                  <MenuItem value={true} sx={{ color: "#1f1f1f" }}>Yes</MenuItem>
                  <MenuItem value={false} sx={{ color: "#1f1f1f" }}>No</MenuItem>
                  <MenuItem value={"any"} sx={{ color: "#1f1f1f" }}>Any</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Generated</InputLabel>
                <Select
                  value={generated}
                  label="Generated"
                  name="generated"
                  onChange={handleChange}
                  sx={filterSelectSx}
                >
                  <MenuItem value={true} sx={{ color: "#1f1f1f" }}>Yes</MenuItem>
                  <MenuItem value={false} sx={{ color: "#1f1f1f" }}>No</MenuItem>
                  <MenuItem value={"any"} sx={{ color: "#1f1f1f" }}>Any</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Email Status</InputLabel>
                <Select
                  value={emailStatus}
                  label="Email Status"
                  name="emailStatus"
                  onChange={handleChange}
                  sx={filterSelectSx}
                >
                  <MenuItem value="any" sx={{ color: "#1f1f1f" }}>Any</MenuItem>
                  <MenuItem value="not sent" sx={{ color: "#1f1f1f" }}>Not sent</MenuItem>
                  <MenuItem value="sent" sx={{ color: "#1f1f1f" }}>Sent</MenuItem>
                  <MenuItem value="delivered" sx={{ color: "#1f1f1f" }}>Delivered</MenuItem>
                  <MenuItem value="opened" sx={{ color: "#1f1f1f" }}>Opened</MenuItem>
                  <MenuItem value="clicked" sx={{ color: "#1f1f1f" }}>Clicked</MenuItem>
                  <MenuItem value="deferred" sx={{ color: "#1f1f1f" }}>Deferred</MenuItem>
                  <MenuItem value="failed" sx={{ color: "#1f1f1f" }}>Failed</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Search"
                value={searchQuery}
                onChange={handleSearchChange}
                onKeyPress={handleSearchKeyPress}
                placeholder="Search by name, email, or phone number"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="flex-end">
                <PlatformButton variant="ghost" onClick={handleClearFilter}>
                  Clear Filters
                </PlatformButton>
                <PlatformButton variant="primary" onClick={handleSearchFilter}>
                  Apply Filters
                </PlatformButton>
              </Stack>
            </Grid>
          </Grid>
        </PlatformCard>

        <Paper 
          elevation={0} 
          sx={{ 
            p: 3, 
            borderRadius: 2,
            backgroundColor: 'var(--platform-surface)',
            border: '1px solid',
            borderColor: '#e0e0e0'
          }}
        >
          {!isLoading ? (
            <TableContainer sx={platformTableContainerSx}>
              <Table sx={{ minWidth: 650, ...platformTableSx }} aria-label="tickets table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Email Status</TableCell>
                    <TableCell>Actions</TableCell>
                    <TableCell align="center">QR Code</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tickets?.docs?.map((ticket) => (
                    <TicketRow
                      key={ticket._id}
                      ticket={ticket}
                      action={action}
                      setAction={setAction}
                    />
                  ))}
                </TableBody>
              </Table>
              {tickets?.docs?.length === 0 && (
                <PlatformEmptyState title="No tickets found" description="Try adjusting your filters." />
              )}
            </TableContainer>
          ) : (
            <PlatformLoadingBlock />
          )}
          <Box sx={{ ...centered_flex_box, mt: 3 }}>
            <Pagination
              count={tickets?.pages || 1}
              page={page}
              onChange={handlePageChange}
              color="primary"
              sx={{
                '& .MuiPaginationItem-root': {
                  borderRadius: 1
                }
              }}
            />
          </Box>
        </Paper>
      </motion.div>
    </PlatformPage>
  );
};

const mapStateToProps = (state) => ({
  tickets: state?.records?.results?.tickets,
  isLoading: state?.records?.isLoading,
});

const mapDispatchToProps = { getEventTickets };

export default connect(mapStateToProps, mapDispatchToProps)(Tickets);
